import { CloseGeneratorDrawerIcon } from '@/components/Icons/CloseGeneratorDrawerIcon';
import Show from '@/components/Show';
import { useDimensions } from '@/hooks/useDimensions';
import useEditorStore from '@/state/editor-store';
import useGeneratorStore, { GeneratorTypeEnums } from '@/state/generator-store';
import useSidebarStore from '@/state/sideBarStore';
import { cn } from '@/utils';
import useFlags from '@jenmusic/feature-flag';
import React, { useEffect } from 'react';
import { FormProvider } from 'react-hook-form';
import DetailEffects from './components/DetailEffects';
import SimpleEffects from './components/SimpleEffects';
import { useModel } from './model';
import { useGeneratorFilterStore } from '@/state/generator-filter-store';

interface GeneratorProps {}

const Generator: React.FC<GeneratorProps> = () => {
  const { generatorLoading, onSubmit, form, RenewFilterModal } = useModel();

  const { isGeneratorDrawerShow, setIsGeneratorDrawerShow, generatorType, setGeneratorType } = useGeneratorStore((state) => ({
    isGeneratorDrawerShow: state.isGeneratorDrawerShow,
    setIsGeneratorDrawerShow: state.setIsGeneratorDrawerShow,
    generatorType: state.generatorType,
    setGeneratorType: state.setGeneratorType,
  }));

  const { setCurrentFilterGroup } = useGeneratorFilterStore();

  const { editor, setOperator } = useEditorStore((state) => ({
    editor: state.editor,
    setOperator: state.setOperator,
  }));
  const { isMobileOrPad } = useDimensions();
  const { isSidebarOpen } = useSidebarStore();
  const { showNewNavigationBar } = useFlags();

  useEffect(() => {
    if (isGeneratorDrawerShow === false) {
      setCurrentFilterGroup(null);
      form.setValue('styleFilterIsOpened', false);
    }
  }, [isGeneratorDrawerShow]);

  const { setDisabled, setCurrentStrength } = useGeneratorFilterStore();

  return (
    <div
      className={cn('col-span-3 row-span-1 z-10 fixed bottom-0 pointer-events-none transition-all flex-shrink-0 duration-300 ease-in-out', {
        'w-[calc(100%-260px)]': showNewNavigationBar && !isMobileOrPad && isSidebarOpen,
        'w-[calc(100%-80px)]': showNewNavigationBar && !isMobileOrPad && !isSidebarOpen,
        'w-full': !showNewNavigationBar || isMobileOrPad,
      })}
    >
      <FormProvider {...form}>
        <form
          className="flex flex-col justify-center items-center"
          onSubmit={(event) => {
            event.preventDefault();
            form.handleSubmit(onSubmit as any)();
          }}
        >
          {/* show drawer (desktop only) */}
          <Show when={isGeneratorDrawerShow && !isMobileOrPad} useDisplayNone={false} direction="bottom" useAnimation={true} distance={110}>
            <div
              style={{
                overflowY: 'auto',
                height: window.screen.availHeight < 720 ? window.screen.availHeight - 120 : '100%',
              }}
            >
              <div className="flex justify-center items-center mb-8 w-fit ml-[calc(50%-50px)] pointer-events-auto">
                <CloseGeneratorDrawerIcon
                  className="cursor-pointer"
                  style={{
                    filter: 'brightness(120%)',
                    transition: 'filter 0.3s ease-in-out',
                  }}
                  onMouseOver={(e) => (e.currentTarget.style.filter = 'brightness(150%)')}
                  onMouseOut={(e) => (e.currentTarget.style.filter = 'brightness(100%)')}
                  onClick={() => {
                    setIsGeneratorDrawerShow(false);
                    if (generatorType === GeneratorTypeEnums.EDITOR) {
                      setDisabled(false);
                      setCurrentStrength(0);
                      editor?.destroy();
                      setGeneratorType(GeneratorTypeEnums.TEXT);
                      setOperator(undefined);
                      form.reset();
                    }
                  }}
                />
              </div>
              <div className="w-full bg-[#2B2D2F] rounded-t-[25px] pointer-events-auto">
                <DetailEffects />
                {/* <DurationInput onChange={handleDurationChange} /> */}
              </div>
            </div>
          </Show>

          <div className="pointer-events-auto w-full">
            <SimpleEffects generatorLoading={generatorLoading} />
          </div>
        </form>
      </FormProvider>
      <RenewFilterModal />
    </div>
  );
};

export default Generator;
